import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      text: 'Secure Login',
      description: 'Protected authentication'
    },
    {
      icon: 'CheckCircle',
      text: 'Verified Platform',
      description: 'Trusted by gamers'
    }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-4 mt-8">
      {securityFeatures.map((feature, index) => (
        <div
          key={index}
          className="flex items-center space-x-2 bg-muted/30 rounded-lg px-3 py-2"
        >
          <Icon name={feature.icon} size={16} className="text-accent" />
          <div>
            <p className="text-xs font-medium text-foreground">{feature.text}</p>
            <p className="text-xs text-muted-foreground">{feature.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;